import React, { PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  condition: boolean;
  wrap: (props: any) => React.ReactNode;
}>;

const ConditionalWrap: React.FC<Props> = ({
  condition,
  wrap: Wrap,
  children,
}) => {
  return condition ? <Wrap>{children}</Wrap> : <>{children}</>;
};

export default ConditionalWrap;
